module.exports = __webpack_public_path__ + "img/twoBgc.3ac6e691.png";